"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regulaExpersions_1 = require("./regulaExpersions");
const utility_1 = require("./utility");
exports.selectNumbers = (input) => {
    const inp = utility_1.removeSpacesFromInput(input);
    return inp.match(regulaExpersions_1.numberRegExp);
};
exports.selectParantheses = (input) => {
    const inp = utility_1.removeSpacesFromInput(input);
    return inp.match(regulaExpersions_1.betweenParenthesesRegExp);
};
exports.selectMultiplicationPhrase = (input) => {
    const inp = utility_1.removeSpacesFromInput(input);
    return inp.match(regulaExpersions_1.multiplicationRegExp);
};
exports.selectDivisionPharse = (input) => {
    const inp = utility_1.removeSpacesFromInput(input);
    return inp.match(regulaExpersions_1.divisionRegExp);
};
exports.selectSummationOrSubtractionPhrase = (input) => {
    return input.match(regulaExpersions_1.summationOrSubtractionRegExp);
};
exports.selectPowerPhrase = (input) => {
    return input.match(regulaExpersions_1.powerRegExp);
};
exports.selectLastPowerPhrase = (input) => {
    return input.match(regulaExpersions_1.lastPowerRegExp);
};
